<template>
  <alert-banner v-if="bannerType" :status="HelperStatus.Warn">
    {{ bannerMessage }}
    <a
      v-if="bannerType === BannerType.PROFILE_HIDDEN"
      href="#"
      class="underline font-medium"
      @click.prevent="$emit('unhide-profile')"
      >Click to unhide
    </a>
  </alert-banner>
</template>

<script lang="ts">
import HelperStatus from '@/helpers/status';
import { BannerType } from '../__types__/ErrorTypes';
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';

export default {
  name: 'ProviderProfileBanner',
  components: {
    AlertBanner,
  },
  props: {
    bannerType: {
      type: String,
      default: BannerType.NONE,
    },
  },
  data(): any {
    return {
      HelperStatus,
      BannerType,
    };
  },
  computed: {
    bannerMessage(): string {
      return this.bannerType === BannerType.PROFILE_HIDDEN
        ? "Profile hidden: Families can't find or contact you for this service when it's hidden."
        : '';
    },
  },
};
</script>
